import {
  HttpClient, HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { apiConfiguration } from '../../../../configurations/api-configuration';
import { AccessService } from '../../../application/services/AccessService';
import { HttpResponse } from '../../../application/types/HttpResponse';
import {
  CalendarEntry,
  SaveCalendarEntryData,
} from '../../types/Workspace';

@Injectable()
export class CalendarApiService {
  private readonly calendarEntriesUrl = `${apiConfiguration.baseApiUrl}/calendar-entries`;

  public constructor(
    private http: HttpClient,
    private accessService: AccessService,
  ) { }

  public async getCalendarEntries(month: string): Promise<HttpResponse<CalendarEntry[]>> {
    return lastValueFrom(this.http.get<HttpResponse<CalendarEntry[]>>(this.calendarEntriesUrl, {
      headers: this.getHeaders(),
      params: { month },
    }));
  }

  public async createCalendarEntry(data: SaveCalendarEntryData): Promise<HttpResponse<CalendarEntry>> {
    return lastValueFrom(this.http.post<HttpResponse<CalendarEntry>>(this.calendarEntriesUrl, data, { headers: this.getHeaders() }));
  }

  public async deleteCalendarEntry(entryId: string): Promise<HttpResponse<void>> {
    return lastValueFrom(this.http.delete<HttpResponse<void>>(`${this.calendarEntriesUrl}/${entryId}`, { headers: this.getHeaders() }));
  }

  private getHeaders(): HttpHeaders {
    const token = this.accessService.getToken();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
  }
}
